module.exports = __webpack_public_path__ + "img/ywbk_t.45697682.png";